import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0F1A14] text-white/80" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img src="/nivara-logo-gold.png" alt="NIVARA" loading="lazy" decoding="async" className="h-10 w-auto" />
            <p className="text-xs text-white/60 leading-relaxed mt-4">
              Schweizer Transporter-Vermietung mit klaren Preisen, voller Versicherung und
              Buchung in unter 3 Minuten.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="tel:+41793966660"
                className="bg-white/10 hover:bg-[#D4AF37] hover:text-black w-10 h-10 flex items-center justify-center transition-colors"
                aria-label="Anrufen"
                data-testid="footer-phone"
              >
                <Phone size={16} />
              </a>
              <a
                href="https://wa.me/41793966660"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-[#25D366] w-10 h-10 flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
              >
                <MessageCircle size={16} />
              </a>
              <a
                href="mailto:main@nivaragroup.ch"
                className="bg-white/10 hover:bg-[#D4AF37] hover:text-black w-10 h-10 flex items-center justify-center transition-colors"
                aria-label="E-Mail"
                data-testid="footer-email"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>

          {/* Standorte */}
          <div>
            <h4 className="font-[Chivo] text-sm font-black uppercase tracking-[0.2em] text-[#D4AF37] mb-4">
              Standorte
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/standort/st-gallen" className="hover:text-white">St. Gallen Oberstrasse</Link></li>
              <li><Link to="/standort/st-gallen-wiesental" className="hover:text-white">St. Gallen Wiesental</Link></li>
              <li><Link to="/standort/bern" className="hover:text-white">Bern</Link></li>
              <li><Link to="/standort/derendingen" className="hover:text-white">Derendingen</Link></li>
              <li><Link to="/standort/bronschhofen" className="hover:text-white">Bronschhofen</Link></li>
            </ul>
          </div>

          {/* Service */}
          <div>
            <h4 className="font-[Chivo] text-sm font-black uppercase tracking-[0.2em] text-[#D4AF37] mb-4">
              Service
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white">Transporter mieten</Link></li>
              <li><Link to="/calendar" className="hover:text-white">Verfügbarkeit</Link></li>
              <li><Link to="/register" className="hover:text-white">Konto erstellen</Link></li>
              <li><Link to="/login" className="hover:text-white">Anmelden</Link></li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-[Chivo] text-sm font-black uppercase tracking-[0.2em] text-[#D4AF37] mb-4">
              Kontakt
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone size={14} className="mt-1 flex-shrink-0 text-[#D4AF37]" />
                <a href="tel:+41793966660" className="hover:text-white">079 396 66 60</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={14} className="mt-1 flex-shrink-0 text-[#D4AF37]" />
                <a href="mailto:main@nivaragroup.ch" className="hover:text-white">main@nivaragroup.ch</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 flex-shrink-0 text-[#D4AF37]" />
                <span>NIVARA Group<br />9552 Bronschhofen</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-white/50 tracking-wide">
            © {year} NIVARA Group · Alle Rechte vorbehalten ·{" "}
            <a href="https://nivaragroup.ch" className="hover:text-white">nivaragroup.ch</a>
          </div>
          <div className="text-xs text-white/40 tracking-wide flex flex-wrap gap-4">
            <Link to="/agb" className="hover:text-white" data-testid="footer-agb">AGB</Link>
            <Link to="/datenschutz" className="hover:text-white" data-testid="footer-privacy">Datenschutz</Link>
            <Link to="/impressum" className="hover:text-white" data-testid="footer-imprint">Impressum</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
